import type { SalesNotification } from './notificationCenter';

type Translate = (text: string) => string;
type Format = (template: string, values: readonly unknown[]) => string;
const authoredSourceEvents = new Set([
  'lead_created', 'lead_updated', 'lead_assigned', 'lead_assigned_info', 'registration_link_used',
  'registration_via_link', 'task_overdue', 'follow_up_created', 'follow_up_reminder_triggered',
  'need_review_resolved', 'need_review_response', 'transfer_request_status_changed',
  'transfer_request_approved', 'transfer_request_rejected', 'lead_addition_request_submitted',
  'lead_addition_request_decision',
]);
const authoredTitles = new Set([
  'Sheet lead updated', 'New sheet lead', 'New lead assigned', 'Registration completed',
  'Task overdue', 'Follow-up due soon', 'Need review response', 'Transfer request rejected',
  'Transfer request approved', 'New Lead request', 'New Lead request approved',
  'New Lead request rejected', 'New Lead request returned for editing',
]);
const authoredDescriptions = new Set([
  'A follow-up task is overdue and needs action now.', 'A follow-up reminder is due soon.',
  'A review request has a new response.', 'Transfer request was rejected. Review reason and next step.',
  'Transfer request was approved.',
]);
const authoredDescriptionTemplates = [
  /^.+ submitted a sales inquiry(?: for .+)?(?: from .+)?\.$/,
  /^A new lead was assigned to you(?: \(Lead #\d+\))?\.$/,
  /^.+ registered from the sales link(?: for .+)?\.$/,
  /^.+ requested adding .+\.$/,
];

/** Translate authored notification copy; unknown external prose and captured customer data stay intact. */
export function notificationDisplayCopy(item: SalesNotification, t: Translate, format: Format) {
  const authoredSource = authoredSourceEvents.has(String(item.metadata?.source_event));
  let description = authoredSource && (authoredDescriptions.has(item.description) || authoredDescriptionTemplates.some(pattern => pattern.test(item.description)))
    ? t(item.description) : item.description;
  if (item.metadata?.source_event === 'lead_addition_request_decision') {
    const match = /^(.*): (approved|rejected|returned for editing|pending)(?: - ([\s\S]*))?\.$/s.exec(item.description);
    if (match) description = format(match[3] ? `{0}: ${match[2]} - {1}.` : `{0}: ${match[2]}.`, [match[1], match[3] || '']);
  }
  return {
    title: authoredSource && authoredTitles.has(item.title) ? t(item.title) : item.title,
    description,
  };
}

export const notificationPriorityLabels = { critical: 'Critical', high: 'High', normal: 'Normal', low: 'Low' } as const;
export const notificationCategoryLabels = { tasks: 'Tasks', leads: 'Leads', whatsapp: 'WhatsApp', requests: 'Requests', system: 'System' } as const;
